// extracted by mini-css-extract-plugin
export default {"RecipesPageBackgroundImange":"RecipesPage_RecipesPageBackgroundImange__I0CQ4","General":"RecipesPage_General__pfUzr","RecipePreparation":"RecipesPage_RecipePreparation__bEMW8"};